<template>
  <milestone-wrapper :subscription-period-id="subscriptionPeriodId" :data="data" :meta="meta">
    <template slot="content-completed">
      <GridTable v-if="items" :columns="columns" :rows="items" class="full-width">
        <template #row="{row}">
          <GridTableCell>{{ row.name }}</GridTableCell>
          <GridTableCell>{{ row.email }}</GridTableCell>
          <GridTableCell class="text-right">
            {{ getStakeProp(row.stakes[0], 'share') ? formatPrice(getStakeProp(row.stakes[0], 'share')) : 'N/A' }}
          </GridTableCell>
          <GridTableCell>{{ getStakeProp(row.stakes[0], 'reference') || 'N/A' }}</GridTableCell>
          <GridTableCell>{{ getStakeProp(row.stakes[0], 'status.name') || 'N/A' }}</GridTableCell>
        </template>
      </GridTable>

      <EmailBatchDisplay v-if="content && content.emails" :email="content.emails[0]" class="q-mt-md" />
    </template>
  </milestone-wrapper>
</template>

<script>
import MilestoneMixin from '@/mixins/milestone.mixin'
// Libraries
import { get } from 'lodash'
// Components
import EmailBatchDisplay from '@/components/lm-blocks/EmailBatchDisplay'
import MilestoneWrapper from '@/components/milestones/MilestoneWrapper'
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    EmailBatchDisplay,
    MilestoneWrapper,
    GridTable,
    GridTableCell
  },

  mixins: [MilestoneMixin],

  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },

  computed: {
    items() {
      return get(this, 'content.stakeholders')
    },

    columns() {
      return [
        { label: 'Stakeholders included', width: '1fr' },
        { label: 'Email', width: '1fr' },
        { label: 'Share', width: '1fr', align: 'right' },
        { label: 'Reference', width: '1fr' },
        { label: 'Status', width: '1fr' }
      ]
    }
  },

  methods: {
    getStakeProp(stake, prop) {
      return get(stake, prop)
    }
  }
}
</script>
